import { Controller } from '@hotwired/stimulus';

/**
 * Drawer - slides the sidebar in on small screens.
 * Targets: panel (the sidebar) | backdrop | toggle (the menu button, gets aria-expanded)
 */
export default class extends Controller {
  static targets = ['panel', 'backdrop', 'toggle'];

  connect () {
    this.onKeydown = (event) => { if (event.key === 'Escape') this.close(); };
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnect () {
    document.removeEventListener('keydown', this.onKeydown);
    this.close();
  }

  open () {
    this.element.classList.add('drawer--open');
    document.body.classList.add('drawer-locked');
    this.#setExpanded(true);
    this.panelTarget.querySelector('a, button')?.focus();
  }

  close () {
    this.element.classList.remove('drawer--open');
    document.body.classList.remove('drawer-locked');
    this.#setExpanded(false);
  }

  #setExpanded (expanded) {
    if (this.hasToggleTarget) this.toggleTarget.setAttribute('aria-expanded', String(expanded));
  }
}
